import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Inspiring%20sports%20silhouette%20at%20sunset%20with%20athletes%20training%20outdoors%2C%20warm%20golden%20hour%20light%2C%20motivational%20atmosphere%2C%20abstract%20geometric%20overlay%2C%20warm%20orange%20and%20amber%20tones%2C%20professional%20cinematic%20style&width=1800&height=800&seq=yunkai-cta-bg&orientation=landscape"
        alt="开启运动之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/85 via-foreground-900/70 to-foreground-900/85"></div>

      <div className="relative z-10 w-full px-6 md:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-background-50 mb-4">
            准备好开启您的运动之旅了吗？
          </h2>
          <p className="text-base text-background-50/75 mb-8 max-w-lg mx-auto leading-relaxed">
            立即联系我们，获取专属体育运动解决方案。无论是个人培训还是企业团建，我们都能为您量身定制。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/about#contact"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              免费咨询
            </Link>
            <a
              href="tel:400-888-6666"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-background-50 font-semibold rounded-lg border border-white/20 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              400-888-6666
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}